import React from "react";
import { Outlet, useLoaderData, useLocation } from "react-router";

import "react-datepicker/dist/react-datepicker.css";

import EjectionReportsTable from "./components/EjectionReportsTable";
import Filters from "./components/Filters";
import FiltersSubRow from "./components/FiltersSubRow";
import {
    EjectionReportsProvider,
    useEjectionReportsContext,
} from "./contexts/EjectionReports";
import { FiltersProvider } from "./contexts/Filters";

import { store } from "../../..";
import "../../../assets/css/umphub/pages/admin.scss";
import Pagination from "../../../components/Pagination";
import { PaginationProvider } from "../../../contexts/Pagination";
import { globalActions } from "../../../features/global/globalSlice";
import { getAllEjectionReports } from "../../../lib/api";
import { IEjectionReport } from "../../../types/api";

export const loader = async () => {
    const { settings, sites, umpires } = store.getState().global;
    const promises = [];
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !umpires.length &&
        promises.push(store.dispatch(globalActions.getUmpires()));

    const [{ reports }] = await Promise.all([
        getAllEjectionReports(),
        promises,
    ]);

    return {
        reports,
    };
};

const EjectionReports = (): React.JSX.Element => {
    const { reports } = useLoaderData() as {
        reports: IEjectionReport[];
    };

    const location = useLocation();
    const isReportPage = location.pathname.match(/\d+\/?$/);

    return (
        <FiltersProvider initialReports={reports}>
            {!isReportPage && <Filters />}
            <PaginationProvider>
                <EjectionReportsProvider initialReports={reports}>
                    {!isReportPage ? (
                        <>
                            <FiltersSubRow />
                            <EjectionReportsTable />
                            <Pagination
                                useContext={useEjectionReportsContext}
                            />
                        </>
                    ) : (
                        <Outlet />
                    )}
                </EjectionReportsProvider>
            </PaginationProvider>
        </FiltersProvider>
    );
};

export default EjectionReports;
